// extracted by mini-css-extract-plugin
export var container = "HomeV3-module--container--xF5v3";
export var backgroundImageContainer = "HomeV3-module--backgroundImageContainer--Dhfbx";
export var backgroundImage = "HomeV3-module--backgroundImage--WEB3X";
export var mainCard = "HomeV3-module--mainCard--UIWI1";
export var content = "HomeV3-module--content--9EM+W";
export var profileHeader = "HomeV3-module--profileHeader--vHsm0";
export var profileHeaderAvatar = "HomeV3-module--profileHeaderAvatar--83ytl";
export var profileHeaderAvatarAndName = "HomeV3-module--profileHeaderAvatarAndName--SW8MM";
export var rootProfilePhotoContainer = "HomeV3-module--rootProfilePhotoContainer--poxGf";
export var profilePhotoContainer = "HomeV3-module--profilePhotoContainer--4vRSy";
export var profilePhoto = "HomeV3-module--profilePhoto--H-faj";
export var scrollView = "HomeV3-module--scrollView--bbp7y";
export var profileDetails = "HomeV3-module--profileDetails--h+qBR";
export var profileDetailsContent = "HomeV3-module--profileDetailsContent--Q6cZc";
export var profileName = "HomeV3-module--profileName--lS6ig";
export var profileSlug = "HomeV3-module--profileSlug---jpkr";
export var profileSubHeader = "HomeV3-module--profileSubHeader--quwCZ";
export var scrollGroup = "HomeV3-module--scrollGroup--BNLA4";
export var linksList = "HomeV3-module--linksList--7UHb3";